import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
//import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import {
//   createBrowserRouter,
//   createRoutesFromElements,
//   RouterProvider,
//   Route,
// } from "react-router-dom";

import "./index.css";
import "preline";

// import P from "./P.tsx";
// import D from "./D.tsx";

const P = lazy(() => import("./P.tsx"));
const D = lazy(() => import("./D.tsx"));
const Login = lazy(() => import("./Login.tsx"));

// import P from "./P";
// import D from "./D";
// import Login from "./Login";

// -----------------------------------------------------------------------

// import Error404 from "./Error404.tsx";
// import Login from "./Login.tsx";
// import DTest from "./dashboard/pages/DTest.tsx";
// import DArtikel from "./dashboard/pages/DArtikel.tsx";

// -----------------------------------------------------------------------

//import App from "./App.tsx";
//import Home from "./web/pages/Home.tsx";

// const App = lazy(() => import("./App.tsx"));
// const Home = lazy(() => import("./web/pages/Home.tsx"));
//import Dashboard from "./Dashboard";

// -----------------------------------------------------------------------

// -----------------------------------------------------------------------

//import Dashboard from "./Dashboard.tsx";
// const Dashboard = lazy(() => import("./Dashboard.tsx"));
// const DHome = lazy(() => import("./dashboard/pages/DHome.tsx"));

// const router = createBrowserRouter(
//   createRoutesFromElements(
//     <Route>
//       <Route
//         path="/"
//         element={
//           <React.Suspense>
//             <App />
//           </React.Suspense>
//         }
//       >
//         <Route path="/" element={<Home />} />
//         <Route path="*" element={<Error404 />} />
//       </Route>
//       <Route
//         path="/admin"
//         element={
//           <React.Suspense>
//             <Dashboard />
//           </React.Suspense>
//         }
//       >
//         <Route path="/admin" element={<DHome />} />
//         <Route path="/admin/test" element={<DTest />} />
//         <Route path="/admin/artikel" element={<DArtikel />} />
//         <Route path="/admin/*" element={<Error404 />} />
//       </Route>
//       <Route path="/login" element={<Login />} />
//     </Route>
//   )
// );

// ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
//   <React.StrictMode>
//     <RouterProvider router={router} />
//   </React.StrictMode>
// );
//import ScrollToTop from "./common/ScrollToTop.js";
//ReactDOM.render(
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <ScrollToTop></ScrollToTop> */}
      <Routes>
        <Route
          path="/*"
          element={
            <React.Suspense>
              <P />
            </React.Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <React.Suspense>
              <Login />
            </React.Suspense>
          }
        />
        <Route
          path="/admin/*"
          element={
            <React.Suspense>
              <D />
            </React.Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
  //document.getElementById("root")
);
